<template>
    <!-- main area -->
    <div class="d-flex align-center justify-center" style="min-height: 300px;">
      About Page!
    </div>
</template>

<script>

export default {
  data () {
    return {
      test: null
    }
  }
}

</script>
